import type { MobileConfig } from "./config-types";

const mobileConfig: MobileConfig = {
  mobile: {
    allowPortraitMode: false,
    minWidth: 768,
    minHeight: 576,

    // Sentry
    sentry: {
      dsn: "https://1a11060853fc4d3898bdc6b014375812@sentry.bike.center/8",
      sendDefaultPii: true
    },

    // Mixpanel tracking config
    mixpanel: {
      token: {
        dev: "1b49cc405933daf2c8d7d2ceb7a00545",
        prod: "98537099b2a1b5b99b78806bc4c82fe1"
      },
      apiHost: {
        dev: "https://api-eu.mixpanel.com",
        prod: "https://api-eu.mixpanel.com"
      },
      sessionTimeout: 5 * 60 * 1000
    }
  }
};

export default mobileConfig;
